// ── KPI Types ────────────────────────────────────────────────────

import type { Id } from "@/packages/types";

export type TimeRange = "7d" | "30d" | "3m";

export type KpiId =
  | "activeAudits"
  | "completedAudits"
  | "openFindings"
  | "missingEvidence"
  | "fixRate"
  | "upcomingDeadlines";

export interface KpiData {
  id: KpiId;
  value: number;
  unit?: string;
  trend?: number;
  invertTrend?: boolean;
}

export const ALL_KPI_IDS: KpiId[] = [
  "activeAudits",
  "completedAudits",
  "openFindings",
  "missingEvidence",
  "fixRate",
  "upcomingDeadlines",
];

export const DEFAULT_VISIBLE_KPIS: KpiId[] = [
  "activeAudits",
  "completedAudits",
  "openFindings",
];

// ── Pipeline Types ───────────────────────────────────────────────

export interface PipelineAudit {
  id?: Id<"audits">;
  name: string;
  client: string;
  due: string;
  fw: string;
  p?: number;
}

export interface PipelineStage {
  status: string;
  count: number;
  color: string;
  audits: PipelineAudit[];
  isCompleted?: boolean;
}

export interface Framework {
  name: string;
  cov: number;
  ctrl: number;
  met: number;
  color: string;
  docCov: number;
  openProcesses: number;
  due: string;
  trigger?: string;
  auditSlug?: Id<"audits">;
  tags: { name: string; color: string }[];
}
